<template>
  <div v-if="!loading" class="px-6">
    <template>
      <v-timeline v-if="timeline.length">
        <v-timeline-item v-for="(time, index) in timeline" :key="index">
          <v-alert outlined prominent color="teal" border="top">
            <div class="d-flex flex-column">
              <span class="text-subtitle-2">
                {{ time.created_at | data }}
              </span>
              <span class="text-h6">
                {{ time.status.descricao }}
              </span>
              <div class="text-body-2 mt-2 d-flex flex-column">
                <span v-if="time.user"> <b>Usuário: </b> {{ time.user }} </span>
                <span v-if="time.justificativa">
                  <b>Justificativa: </b> {{ time.justificativa }}
                </span>
                <span v-if="time.observacao">
                  <b>Observação: </b> {{ time.observacao }}
                </span>
                <span v-if="time.arquivo">
                  <b>Arquivo: </b> {{ time.arquivo.nome }}
                  <span v-if="time.arquivo.zip">
                    dentro de {{ time.arquivo.zip }}
                  </span>
                  <span v-else>ainda não foi enviado.</span>
                </span>
              </div>
            </div>
          </v-alert>
        </v-timeline-item>
      </v-timeline>
      <v-alert
        v-else
        text
        prominent
        color="blue"
        class="mt-4"
        icon="mdi-compass-outline"
      >
        Nenhuma movimentação foi encontrada para este auto.
      </v-alert>
    </template>
  </div>
  <div v-else class="px-8 py-10 text-center">
    <span>Carregando histórico...</span>
  </div>
</template>
<script>
import urlApi from "@/routes/urlApi";

export default {
  name: "TimeLine",

  props: {
    idAuto: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      timeline: [],
      loading: true,
    };
  },

  methods: {
    getLogs() {
      this.$http
        .get(`${urlApi}/v2/autos/${this.idAuto}/status_logs`)
        .then((response) => {
          this.timeline = response.data.logs;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    generateReport() {
      this.$refs.html2Pdf.generatePdf();
    },
  },
  mounted() {
    this.getLogs();
  },
};
</script>
